import { useCallback } from 'react';
import type { Container, Engine } from "tsparticles-engine";
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";

const ParticleBackground = () => {
    const particlesInit = useCallback(async (engine: Engine) => {
        await loadSlim(engine);
    }, []);

    const particlesLoaded = useCallback(async (container: Container | undefined) => {
        console.log("Particles container loaded");
    }, []);

    return (
        <Particles
            id="tsparticles"
            init={particlesInit}
            loaded={particlesLoaded}
            className="particle-container"
            options={{
                background: {
                    color: {
                        value: '#f0f4f8',
                    },
                },
                fullScreen: {
                    enable: true,
                    zIndex: -1
                },
                fpsLimit: 120,
                interactivity: {
                    events: {
                        onClick: {
                            enable: true,
                            mode: "push",
                        },
                        onHover: {
                            enable: true,
                            mode: "repulse",
                        },
                        resize: true,
                    },
                    modes: {
                        repulse: {
                            distance: 150,
                            duration: 0.4,
                        },
                        push: {
                            quantity: 2,
                        }
                    },
                },
                particles: {
                    color: {
                        value: ["#356BAD", "#a8cde8", "#c5ddf0"]
                    },
                    links: {
                        color: "#356BAD",
                        distance: 150,
                        enable: true,
                        opacity: 0.3,
                        width: 1,
                    },
                    move: {
                        direction: "none",
                        enable: true,
                        outModes: {
                            default: "bounce",
                        },
                        random: false,
                        speed: 1,
                        straight: false,
                        attract: {
                            enable: true,
                            rotate: {
                                x: 600,
                                y: 1200
                            }
                        }
                    },
                    number: {
                        density: {
                            enable: true,
                            area: 800,
                        },
                        value: 80,
                    },
                    opacity: {
                        value: { min: 0.3, max: 0.7 },
                        animation: {
                            enable: true,
                            speed: 0.3,
                            minimumValue: 0.3,
                            sync: false
                        }
                    },
                    shape: {
                        type: "circle",
                    },
                    size: {
                        value: { min: 1, max: 3 },
                        animation: {
                            enable: true,
                            speed: 2,
                            minimumValue: 1,
                            sync: false
                        }
                    },
                },
                detectRetina: true,
            }}
        />
    );
};

export default ParticleBackground; 